import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.PowerAnytime');

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741080179539/pany-pc-1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741080179164/pany-pad-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741080178818/pany-h5-1.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741080179713/pany-pc-2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741080179361/pany-pad-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741080178989/pany-h5-2.jpg',
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={items} loop={true} />
            <EfSpec />
        </div>
    );
}
